import { firestore } from "firebase/app";

export function deleteUndefined(obj: object, isUpdate?: boolean) {
  const keys = Object.keys(obj) as Array<keyof typeof obj>;

  keys.forEach((key) => {
    if (
      obj[key] &&
      typeof obj[key] === "object" &&
      !((obj as any)[key] instanceof firestore.FieldValue)
    ) {
      deleteUndefined(obj[key], isUpdate);
    } else if (obj[key] === undefined) {
      if (isUpdate) {
        // TODO: Find a way to replace `as any`!
        (obj as any)[key] = firestore.FieldValue.delete();
      } else {
        delete obj[key];
      }
    }
  });

  return obj;
}
